import { motion } from "framer-motion";
import { BrainCircuit, Cpu, Workflow } from "lucide-react";
import { useLanguage } from "@/i18n";

const ICONS = [Workflow, BrainCircuit, Cpu];

export default function Manifesto() {
  const { t } = useLanguage();

  return (
    <section data-testid="manifesto-section" className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <span className="font-pixel text-[10px] tracking-[0.4em] text-purple-400">// {t.manifesto.label}</span>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          {t.manifesto.title}
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
        {t.manifesto.chapters.map((ch, i) => {
          const Icon = ICONS[i];
          return (
            <motion.article
              key={ch.num}
              data-testid={`manifesto-chapter-${ch.num}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className={`group relative overflow-hidden border border-white/10 bg-[#0A0D24]/60 p-8 transition-colors duration-500 hover:border-cyan-400/40 sm:p-10 ${
                i === 0 ? "md:col-span-7" : i === 1 ? "md:col-span-5" : "md:col-span-12 lg:col-span-12"
              }`}
            >
              <span className="font-pixel pointer-events-none absolute -right-3 -top-6 text-[7rem] leading-none text-white/[0.04] transition-colors duration-500 group-hover:text-cyan-400/10 sm:text-[9rem]">
                {ch.num}
              </span>
              <div className="relative">
                <div className="mb-6 flex items-center gap-4">
                  <span className="pixel-corners-sm flex h-11 w-11 items-center justify-center border border-cyan-400/30 bg-cyan-400/10 text-cyan-300">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-pixel text-[10px] tracking-[0.35em] text-slate-500">{ch.num} /</span>
                </div>
                <h3 className="font-display text-xl font-semibold text-white sm:text-2xl">{ch.title}</h3>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">{ch.text}</p>
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}
